var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panel",
    [
      _c("v-expansion-panel-header", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var open = ref.open
              return [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "text--secondary", attrs: { cols: "12" } },
                      [
                        _c(
                          "v-fade-transition",
                          { attrs: { "leave-absolute": "" } },
                          [
                            open
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          absolute: "",
                                          dark: "",
                                          fab: "",
                                          center: "",
                                          right: "",
                                          color: "pink",
                                        },
                                        on: {
                                          click:
                                            _vm.removePgaValutazioneOffertaAltreComponentiCreate,
                                        },
                                      },
                                      [_c("v-icon", [_vm._v("mdi-minus")])],
                                      1
                                    ),
                                    _c("span", [
                                      _vm._v("Dettaglio altre componenti"),
                                    ]),
                                  ],
                                  1
                                )
                              : _c(
                                  "v-row",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _c("v-col", { attrs: { cols: "2" } }, [
                                      _vm._v(
                                        "Tipologia: " +
                                          _vm._s(
                                            _vm.TipologiaComponente ||
                                              "Non impostato"
                                          )
                                      ),
                                    ]),
                                    _c("v-col", { attrs: { cols: "2" } }, [
                                      _vm._v(
                                        "Importo Offerta: " +
                                          _vm._s(
                                            _vm.ImportoOffertaComponente +
                                              "€" || "Non impostato"
                                          )
                                      ),
                                    ]),
                                    _c("v-col", { attrs: { cols: "2" } }, [
                                      _vm._v(
                                        "Costo: " +
                                          _vm._s(
                                            _vm.CostoAttesoComponente + "€" ||
                                              "Non impostato"
                                          )
                                      ),
                                    ]),
                                    _c("v-col", { attrs: { cols: "2" } }, [
                                      _vm._v(
                                        "Margine: " +
                                          _vm._s(
                                            _vm.MargineAttesoPercComponente +
                                              "%" || "Non impostato"
                                          )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "v-expansion-panel-content",
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "2" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.BusinessLineItemsComponente,
                      label: "Business Line",
                      required: "",
                      rules: [
                        function (v) {
                          return !!v || "Item is required"
                        },
                      ],
                    },
                    model: {
                      value: _vm.BusinessLineComponente,
                      callback: function ($$v) {
                        _vm.BusinessLineComponente = $$v
                      },
                      expression: "BusinessLineComponente",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "2" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.TechAreaItemsComponente,
                      label: "Tech Area",
                      required: "",
                      rules: [
                        function (v) {
                          return !!v || "Item is required"
                        },
                      ],
                    },
                    model: {
                      value: _vm.TechAreaComponente,
                      callback: function ($$v) {
                        _vm.TechAreaComponente = $$v
                      },
                      expression: "TechAreaComponente",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "2" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.TipologiaFornituraItemsComponente,
                      label: "Tipologia Fornitura",
                      required: "",
                      rules: [
                        function (v) {
                          return !!v || "Item is required"
                        },
                      ],
                    },
                    model: {
                      value: _vm.TipologiaFornituraComponente,
                      callback: function ($$v) {
                        _vm.TipologiaFornituraComponente = $$v
                      },
                      expression: "TipologiaFornituraComponente",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "2" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.TipologiaComponenteitems,
                      label: "Tipologia Componente",
                      required: "",
                      rules: [
                        function (v) {
                          return !!v || "Item is required"
                        },
                      ],
                    },
                    model: {
                      value: _vm.TipologiaComponente,
                      callback: function ($$v) {
                        _vm.TipologiaComponente = $$v
                      },
                      expression: "TipologiaComponente",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "2", md: "2" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      prefix: "€",
                      label: "Importo Offerta",
                      type: "number",
                    },
                    model: {
                      value: _vm.ImportoOffertaComponente,
                      callback: function ($$v) {
                        _vm.ImportoOffertaComponente = $$v
                      },
                      expression: "ImportoOffertaComponente",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "2", md: "2" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      prefix: "€",
                      label: "Costo Atteso",
                      type: "number",
                    },
                    model: {
                      value: _vm.CostoAttesoComponente,
                      callback: function ($$v) {
                        _vm.CostoAttesoComponente = $$v
                      },
                      expression: "CostoAttesoComponente",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "2", md: "2" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Margine Atteso",
                      type: "number",
                      readonly: "",
                    },
                    model: {
                      value: _vm.MargineAttesoComponente,
                      callback: function ($$v) {
                        _vm.MargineAttesoComponente = $$v
                      },
                      expression: "MargineAttesoComponente",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "2", md: "2" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      prefix: "%",
                      label: "Margine Atteso %",
                      type: "number",
                      readonly: "",
                    },
                    model: {
                      value: _vm.MargineAttesoPercComponente,
                      callback: function ($$v) {
                        _vm.MargineAttesoPercComponente = $$v
                      },
                      expression: "MargineAttesoPercComponente",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }